'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import gui from '@/store/modules/gui'
import session from '@/store/modules/session'
import timer from '@/store/modules/timer'
import network from '@/store/modules/network'
import info from '@/store/modules/info'
import playlist from '@/store/modules/playlist'
import board from '@/store/modules/board'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    gui,
    timer,
    session,
    network,
    info,
    playlist,
    board
  },
  state: {},
  mutations: {},
  actions: {}
})
